$(document).ready(function(){
       let div_height = $('.block__test-drive-service-card-content').outerHeight()
       $('.block__test-drive-service-card-images').css('height', div_height); 
       $('.block__test-drive-service-card-slider').slick({
           draggable: false,
           infinite: true,
           autoplay: true,
           arrows: false,
           autoplaySpeed: 0,
           speed: 6000,
           pauseOnHover:false,
           slidesToShow: 4,
           cssEase: 'linear',
           vertical: true,
           responsive: [
               {
                 breakpoint: 768,
                 settings: {
                   slidesToShow: 4,
                 }
               }
           ]
       });
       $('.block__test-drive-service-card-slider-reverse').slick({
         draggable: false,
         infinite: true,
         arrows: false,
         autoplaySpeed: 0,
         speed: 6000,
         pauseOnHover:false,
         slidesToShow: 4,
         cssEase: 'linear',
         vertical: true,
         responsive: [
             {
               breakpoint: 768,
               settings: {
                 slidesToShow: 4,
               }
             }
         ]
     });
     setInterval(function() {
       $('.block__test-drive-service-card-slider-reverse').slick('slickPrev');
   }, 50);
});



